// Module
var code = "<mb-file-input ng-model=\"files\" mb-progress mb-drag mb-preview mb-accept=\"image/*\"> </mb-file-input>";
// Exports
var _module_exports =code;;
var path = '/viraweb123/vw-dashboard/src/modules/user/wizards/account-create/avatarPage.html';
window.angular.module('mblowfishApp').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;